import { IStyle, classNamesFunction, IButtonStyles, ITheme } from '@fluentui/react';
import { IThemedProp } from './themesUI';

export interface IAttachmentsStyles {
  title: IStyle;
  informationText: IStyle;
  container: IStyle;
  attachmentContainer: IStyle;
  name: IStyle;
  iconContainer: IStyle;
  spinnerIconButton: IStyle;
  cancelIconButton: IStyle;
  deleteIconButton: IStyle;
  downloadIconButton: IStyle;
  uploadButtonInput: IStyle;
  uploadButtonLink: IStyle;
  errorMessage: IStyle;
}

// Overrides icon size to minimum accessibility-recommended size
export const iconStyle: IButtonStyles = {
  icon: {
    fontSize: '24px',
    lineHeight: '26px',
    width: '24px',
    height: '24px',
  }
};

export const getAttachmentsStyles = (props: IThemedProp): IAttachmentsStyles => {
  const { theme } = props;
  return {
    title: {
      fontWeight: '500',
    },
    informationText: {
      color: theme.palette.neutralPrimary,
      fontSize: '12px',
      marginBottom: '10px',
    },
    container: {
      marginTop: '5px',
      display: 'flex',
      justifyContent: 'space-between',
      marginBottom: '5px',
      maxWidth: '100%',
    },
    attachmentContainer: {
      display: 'flex',
      maxWidth: '90%',
      overflow: 'hidden',
    },
    name: {
      fontSize: '14px',
      justifyContent: 'flex-start',
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
    },
    iconContainer: {
      display: 'flex',
    },
    spinnerIconButton: {
      marginBottom: '7px',
    },
    cancelIconButton: {
      height: '24px',
      width: '24px',
      paddingTop: '2px',
      background: 'none !important',
      color: theme.semanticColors.link,
      marginLeft: '2px',
      marginRight: '8px',
    },
    deleteIconButton: {
      height: '24px',
      width: '24px',
      paddingTop: '2px',
      background: 'none !important',
      color: theme.semanticColors.link,
      marginLeft: '2px',
      marginRight: '8px',
    },
    downloadIconButton: {
      height: '24px',
      width: '24px',
      paddingTop: '2px',
      background: 'none !important',
      color: theme.semanticColors.link,
    },
    uploadButtonInput: {
      display: 'none !important',
    },
    uploadButtonLink: {
      color: theme.semanticColors.link,
      background: 'none !important',
      fontSize: '14px',
    },
    errorMessage: {
      fontSize: '12px',
      color: `${theme.palette.red} !important`,
    },
  };
};

export const getRequestConfirmButtonStyles = (props: { theme: ITheme, withBorderRadius?: boolean }): IButtonStyles => {
  const { theme } = props;
  return {
    root: {
      selectors: {
        '@media screen and (-ms-high-contrast: active), screen and (forced-colors: active)': {
          color: 'window !important',
          backgroundColor: 'windowtext !important',
          borderColor: 'windowtext !important',
          forcedColorAdjust: 'none',
        },
      },
      borderColor: `${theme.palette.themeTertiary} !important`,
      borderRadius: props.withBorderRadius ? '4px' : '0px',
      padding: '6px 12px',
      margin: '15px 10px 15px 0',
      verticalAlign: 'middle',
      fontFamily: 'inherit',
    },
    rootDisabled: {
      selectors: {
        '@media screen and (-ms-high-contrast: active), screen and (forced-colors: active)': {
          color: 'graytext !important',
          backgroundColor: 'window !important',
          borderColor: 'graytext !important',
          forcedColorAdjust: 'none',
        },
      },
      pointerEvents: 'none',
      cursor: 'not-allowed',
      filter: 'alpha(opacity=65)',
      boxShadow: 'none',
      opacity: '.65',
    },
    rootHovered: {
      selectors: {
        '@media screen and (-ms-high-contrast: active), screen and (forced-colors: active)': {
          color: 'window !important',
          backgroundColor: 'highlight !important',
          borderColor: 'highlight !important',
        },
      },
      borderColor: theme.palette.themeDark,
    },
    rootFocused: {
      selectors: {
        '@media screen and (-ms-high-contrast: active), screen and (forced-colors: active)': {
          backgroundColor: 'windowtext !important',
        },
      },
      backgroundColor: `${theme.palette.themeDark} !important`,
      borderColor: `${theme.palette.blueDark} !important`,
      outline: '5px auto -webkit-focus-ring-color',
      outlineOffset: '-2px',
      textDecoration: 'none',
    },
    rootPressed: {
      selectors: {
        '@media screen and (-ms-high-contrast: active), screen and (forced-colors: active)': {
          backgroundColor: 'windowtext !important',
        },
      },
      borderColor: `${theme.palette.blueDark} !important`,
      outline: '5px auto -webkit-focus-ring-color',
      outlineOffset: '-2px',
      textDecoration: 'none',
    },
    label: {
      lineHeight: '1.42857143',
      fontWeight: '400',
      fontSize: '14px',
    },
  };
};

export const getAttachmentsClassNames = classNamesFunction<{}, IAttachmentsStyles>();
